// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M0.999512 3H13.9995V5H2.99951V15H20.9995V11H22.9995V19H0.999512V3ZM3.99951 21H19.9995V23H3.99951V21Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M20.0006 1.00195V5.58769L21.5011 4.08706L22.9154 5.50125L19.0006 9.41619L15.0838 5.49941L16.4981 4.0852L18.0006 5.58772V1.00195L20.0006 1.00195Z"}}]};

const InstallDesktopFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'install-desktop-filled',
    ref,
    icon: element,
  },
));

InstallDesktopFilledIcon.displayName = 'InstallDesktopFilledIcon';

export default InstallDesktopFilledIcon;
